<template>
    <div>
        <div class="header">
            <div class="text-header">
                {{ headerText }}
            </div>
            <div class="action-header">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    :disabled="!enableButton"
                    width="180"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="save()"
                    v-if="meta.status != 'APV'"
                    width="180"
                    :disabled="!status || !enableButton"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.save') }}
                </v-btn>
            </div>
        </div>

        <div class="inquiry-form-container locale-font" ref="containerStyle">
            <v-card class="content-container inquiry-profile">
                <v-container class="pa-inquiry-review" ref="profileInquiry">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <profile :img="meta.employeeImage"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.name') }}
                                    </div>
                                    <div class="form-text">{{ meta.name }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.department') }}
                                    </div>
                                    <div class="form-text">{{ meta.department }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.group') }}
                                    </div>
                                    <div class="form-text">{{ meta.group }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.status') }}
                                    </div>
                                    <div class="form-text">{{ meta.status }}</div>

                                    <div class="form-label">
                                        {{  $vuetify.lang.t('$vuetify.inquiryForm.startStatus') }}
                                    </div>
                                    <div class="form-text">{{ meta.statusStart }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.endStatus') }}
                                    </div>
                                    <div class="form-text">{{ meta.statusEnd }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="pt-1">
                        <v-col cols="4" class="stat">
                            <div class="stat-text">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.personalLeave') }}
                            </div>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.quota') }}
                                </v-col>
                                <v-col cols="6" class="stat-text">{{ meta.personalLeave.quota }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.used') }}
                                </v-col>
                                <v-col cols="6" class="stat-text">{{ meta.personalLeave.used }}</v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="4" class="stat">
                            <div class="stat-text">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.sickLeave') }}
                            </div>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.quota') }}
                                </v-col>
                                <v-col cols="6" class="stat-text">{{ meta.sickLeave.quota }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.used') }}
                                </v-col>
                                <v-col cols="6" class="stat-text">{{ meta.sickLeave.used }}</v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="4" class="stat">
                            <div class="stat-text">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.onSite') }}
                            </div>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.count') }}
                                </v-col>
                                <v-col cols="6" class="stat-text">{{ meta.onsite.count }}</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="content-container inquiry-status">
                <v-container class="pa-inquiry-review" ref="statusInquiryCard">
                    <v-row class="ma-0 card-header" ref="statusInquiryHeader">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.inquiryStatus') }}
                    </v-row>
                    <v-row
                        class="mt-4 mb-4"
                        :class="statusClass(meta.leaveType['key'])"
                        ref="statusInquiryType">
                        <span>{{ meta.leaveType['value'] }}</span>
                        <div class="elipse"></div>
                        <span>{{ meta.date }}</span>
                        <div class="elipse"></div>
                        <span>{{ meta.period }}</span>
                    </v-row>
                    <v-row class="ma-0" ref="statusInquiryDescription">
                        <v-col
                            class="px-0 py-0"
                            cols="9">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.description') }}
                            </div>
                            <div class="form-text">{{ meta.description }}</div>
                        </v-col>
                        <v-col
                            v-if="meta.file"
                            class="px-0 py-0"
                            cols="3">
                            <div class="form-label text-center">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.attachment') }}
                            </div>
                            <div class="download-container">
                                <div
                                    class="pt-2 hover-cursor"
                                    @click="downloadFile()">
                                    <div class="download-container">
                                        file
                                    </div>
                                    <div class="download-text mt-1">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.downloadFile') }}
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row  v-if="meta.status != 'APV'" class="pt-5" ref="statusInquiryApproval">
                        <div class="choices-container" ref="statusContainer">
                            <div
                                :class="choiceClass('APV')"
                                @click="changeStatus('APV')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.approve') }}
                            </div>
                            <div
                                :class="choiceClass('REJ')"
                                @click="changeStatus('REJ')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.reject') }}
                            </div>
                        </div>
                    </v-row>
                    <v-row class="ma-0" v-if="meta.onsiteLocationList.length">
                        <v-col
                            class="px-0 py-0"
                            cols="9">
                            <div class="form-label mt-5">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.checkInLocation') }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-list :style="displayItemListHeight">
                        <template>
                            <v-list-item
                                class="mb-4 locale-font-text item-list-backgorud"
                                v-for="(location, index) in meta.onsiteLocationList"
                                :key="`${index}`">
                                <v-list-item-icon>
                                    <i class="fas fa-map-marker-alt item-list-icon"></i>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle class="text-wrap item-list-content" >
                                        {{ location.address }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action class="item-list-action">
                                    {{ converToShortTime(location.time) }}
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-container>
            </v-card>
            <v-card class="content-container inquiry-contact">
                <v-container class="pa-inquiry-review" ref="contactInquiry">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.contact') }}
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pt-0">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.emailAddress') }}
                            </div>
                            <div class="form-text">{{ meta.email }}</div>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.phoneNumber') }}
                            </div>
                            <div class="form-text">{{ meta.phoneNum }}</div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import Profile from '@/components/Profile'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'OnsiteForm',

    components: {
        Profile
    },

    computed: {
        headerText () {
            return this.$vuetify.lang.t('$vuetify.inquiryForm.inquiry')
        },

        displayItemListHeight () {
            const style = { 'overflow-y': 'auto' }
            if (this.itemListMaxHeight) {
                style['max-height'] = `${this.itemListMaxHeight}px`
            }
            return style
        }
    },

    data () {
        return {
            status: null,
            inquiryId: null,
            enableButton: true,
            itemListMaxHeight: null,
            meta: {
                name: null,
                email: null,
                phoneNum: null,
                department: null,
                group: null,
                status: null,
                statusStart: null,
                statusEnd: null,
                file: null,
                onsiteLocationList: [],
                employeeImage: profileDefault,
                leaveType: [],
                date: null,
                period: null,
                personalLeave: {
                    quota: null,
                    used: null
                },
                sickLeave: {
                    quota: null,
                    used: null
                },
                onsite: {
                    count: null
                }
            }
        }
    },

    methods: {
        cancel () {
            this.$router.push({ name: 'Inquiry' }, () => {})
        },

        async save () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`leave-or-onsite/update-status/${this.inquiryId}`, {
                status: this.status
            })
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                // this.disableChoices()
                this.enableButton = false
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.congratulation'),
                    text: `${this.$vuetify.lang.t('$vuetify.inquiryForm.applicationStatus')} ${this.meta.name} ${this.$vuetify.lang.t('$vuetify.inquiryForm.isUpdated')}`,
                    type: 'success'
                })

                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.redirecting'),
                    text: this.$vuetify.lang.t('$vuetify.inquiryForm.returnToInuiry'),
                    type: 'info'
                })

                await this.getInquiry(this.inquiryId)

                setTimeout(() => {
                    this.cancel()
                }, 3000)
            }
        },

        async getInquiry (id) {
            const res = await this.axios.get(`leave-or-onsite/get-inquiry-detail/${id}`)
            if (res && res.data && res.data.status === 'ok') {
                this.meta = res.data.data

                if (!this.meta.employeeImage) {
                    this.meta.employeeImage = profileDefault
                }
                if (this.meta.onsiteLocationList.length > 0) {
                    this.setItemListHeight()
                }
                if (!this.meta.description) {
                    this.meta.description = '-'
                }
            }
        },

        setItemListHeight () {
            // Total container Height
            const heightProfile = this.$refs.profileInquiry.clientHeight
            const heightContact = this.$refs.contactInquiry.clientHeight
            const elementContainer = this.$refs.containerStyle
            const rowGapContainer = parseFloat(window.getComputedStyle(elementContainer, null).getPropertyValue('row-gap').substr(0, 2))
            // Inquiry Status Height
            const elementStatusInquiryCard = this.$refs.statusInquiryCard
            const paddingStatusInquiryCard = parseFloat(window.getComputedStyle(elementStatusInquiryCard, null).getPropertyValue('padding-top').substr(0, 2))
            const elementStatusInquiryHeader = this.$refs.statusInquiryHeader
            const marginStatusInquiryHeader = parseFloat(window.getComputedStyle(elementStatusInquiryHeader, null).getPropertyValue('margin-bottom').substr(0, 2))
            const elementStatusInquiryType = this.$refs.statusInquiryType
            const marginTopStatusInquiryType = parseFloat(window.getComputedStyle(elementStatusInquiryType, null).getPropertyValue('margin-top').substr(0, 2))
            const marginBotStatusInquiryType = parseFloat(window.getComputedStyle(elementStatusInquiryType, null).getPropertyValue('margin-bottom').substr(0, 2))
            const elementStatusInquiryDescription = this.$refs.statusInquiryDescription.clientHeight
            const elementStatusInquiryApproval = this.$refs.statusInquiryApproval
            const paddingTopStatusInquiryApproval = parseFloat(window.getComputedStyle(elementStatusInquiryApproval, null).getPropertyValue('padding-top').substr(0, 2))

            this.itemListMaxHeight = (heightProfile + heightContact + rowGapContainer) -
                (paddingStatusInquiryCard + elementStatusInquiryHeader.clientHeight + marginStatusInquiryHeader +
                elementStatusInquiryType.clientHeight + marginTopStatusInquiryType + marginBotStatusInquiryType + elementStatusInquiryDescription +
                elementStatusInquiryApproval.clientHeight + paddingTopStatusInquiryApproval + 32) // For Check-in Label Height 32px
        },

        choiceClass (statusChoice) {
            const style = 'choice'
            if (this.status === statusChoice) {
                return `${style} active`
            }

            return style
        },

        changeStatus (statusChoice) {
            this.status = statusChoice
        },

        disableChoices () {
            this.$refs.statusContainer.children.forEach((child) => {
                child.classList.add('disable')
            })
        },

        statusClass (leaveType) {
            const base = 'ma-0 inquiry-status-label'
            if (leaveType && leaveType === 'ONS') {
                return `${base} text-yellow `
            }

            return `${base} text-red`
        },

        converToShortTime (fullFormatTime) {
            const spiltTime = fullFormatTime.split(':')
            if (spiltTime[0] > 11 && this.$vuetify.lang.current === 'en') {
                return `${('0' + (spiltTime[0] - 12)).slice(-2)}:${spiltTime[1]} ${this.$vuetify.lang.t('$vuetify.inquiryForm.pmTime')}`
            } else {
                return `${spiltTime[0]}:${spiltTime[1]} ${this.$vuetify.lang.t('$vuetify.inquiryForm.amTime')}`
            }
        },

        async downloadFile () {
            this.$store.dispatch('setLoading', true)
            const response = await this.axios.get(`leave-or-onsite/download-inquiry/${this.inquiryId}`, { responseType: 'blob' })
            if (response && response.data) {
                const contentType = response.headers['content-type']
                const splitedContentType = contentType.split('/')

                const blob = new Blob([response.data])
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `inquiry-by-${this.meta.name}.${splitedContentType[1]}`
                link.click()
                URL.revokeObjectURL(link.href)
            }
            this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        const { id } = this.$route.params
        if (id) {
            this.inquiryId = id
            await this.getInquiry(id)
        }
    },
    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.inquiryId) {
                    await this.getInquiry(this.inquiryId)
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.content-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
}

.inquiry-form-container {
    display: grid;
    min-height: 100%;
    height: 100%;
    margin-bottom: 2rem;
    grid-gap: 25px;
    grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
    color: white;

    .card-header {
        font-size: 24px;
        margin-bottom: 24px !important;
    }

    .form-label {
        font-size: 14px;
        color: #6c6c6c;
        line-height: 1.29;
        margin-bottom: 5px;

        &:not(:first-child) {
            margin-top: 23px;
        }
    }

    .form-text {
        font-size: 16px;
        line-height: 1.19;
        color: #131410;
    }

    .stat {
        & > *:not(:first-child) {
            margin-top: 10px;
        }

        .stat-text {
            padding-top: 0px;
            padding-bottom: 0px;
            font-size: 16px;
            color: #131410;
        }

        .stat-label {
            padding-top: 0px;
            padding-bottom: 0px;
            font-size: 16px;
            color: #6c6c6c;
        }
    }
}

.inquiry-profile {
    grid-column: 1 / 2;
    grid-row: 1;
}

.inquiry-status {
    grid-column: 2 / 2;
    grid-row: 1 / 3;
    height: fit-content;
}

.inquiry-contact {
    grid-column: 1 / 2;
    grid-row: 2;
}

.pa-inquiry-review {
    padding: 40px;
}

.profile-container {
    display: flex;
    justify-content: center;
}

.item-list-backgorud {
    background-color: #f9f1e6;
    font-size: 16px;
    border-radius: 10px;
}

.v-list-item__icon {
    align-self: center;
    color: #e8ac8f;
    justify-content: center;
    margin: 0px 16px 0px 0px !important;
}

.item-list-content {
    line-height: 1.44;
    font-size: 16px;
    padding: 4px;
    color: #131410 !important;
}

.item-list-action {
    color: #a8a8a8;
    margin-left: 43px !important;
}

.choices-container {
    display: inline-flex;
    padding: 0px 16px;

    .disable {
        pointer-events: none;
        cursor: not-allowed;
    }

    .choice {
        font-size: 18px;
        height: 50px;
        min-width: 180px;
        width: 50%;
    }

    .choice:first-child {
        color: #6c98ba;
        border: solid 2px #6c98ba;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;

        &:hover {
            background-color: lighten($color: #6c98ba, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #6c98ba;
        }
    }

    @media only screen and (max-width: 1850px) {
        .choice {
            min-width: 135px;
        }
    }

    @media only screen and (max-width: 1500px) {
        .choice {
            min-width: 120px;
        }
    }

    @media only screen and (max-width: 1390px) {
        .choice {
            min-width: 110px;
        }
    }

    .choice:last-child {
        color: #ff544a;
        border: solid 2px #ff544a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        &:hover {
            background-color: lighten($color: #ff544a, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #ff544a;
        }
    }
}
.icon {
    width: 21px;
    height: 24px;
}
.download-container {
    display: flex;
    justify-content: center;
    background-color: #f9f1e6;
}
.attachment {
    display: flex;
    justify-content: center;
    font-weight: bold;
}
.download-text {
    font-size: 11px;
    color: #6c6c6c;
}
.hover-cursor{
    cursor: pointer;
}
.center {
    display: flex;
    justify-content: center;
}
.bold {
    font-weight: bold;
}
</style>
